import React from 'react';
import { UiFileUploader } from '../ui-kit';

/* eslint-disable react/prop-types */
export function UiFileUploaderAdapter({ input, meta, ...rest }) {
  return (
    <UiFileUploader
      {...input}
      {...rest}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
